// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"eafb281e","87":"53f34cca","188":"8842ad6b","532":"8d892070","911":"a3a58316","931":"1e44c9b4","999":"46a408e4"}[chunkId] + ".chunk.js";
};